import { Component, computed, inject, OnInit, output } from '@angular/core';

import { getPropsFrom } from '../../../../utils/xmlParser';
import { MatIcon } from '@angular/material/icon';
import { BaseItemComponent } from '../../common-items/BaseItem/base-item-form.component';
import { BaseItemProperties, DEFAULT_BASE_PROPERTIES } from '../../common-items/BaseItem/base-item-properties';
import { LiveFormsTranslateLoaderService } from '../../../services/live-forms-translate-loader.service';

@Component({
  selector: 'lfe-repeater-item-form',
  imports: [MatIcon],
  templateUrl: './repeater-item-form.component.html',
  standalone: true,
  styleUrl: './repeater-item-form.component.css'
})
export class RepeaterItemFormComponent extends BaseItemComponent<Record<string, any>> implements OnInit {
  translateService = inject(LiveFormsTranslateLoaderService);

  addNewInstanceRequired = output<{ repeatItemId: string; repeaterItemId: string }>();

  properties: BaseItemProperties = {
    ...DEFAULT_BASE_PROPERTIES
  };

  currentId = computed(() => this.properties.customId || this.properties.id);

  htmlId = computed(() => `repeater_${this.currentId()}`);

  onRequestNewInstance() {
    this.addNewInstanceRequired.emit({ repeatItemId: this.sectionItemId(), repeaterItemId: this.currentId() });
  }

  extractLocalProperties(xml: Element): BaseItemProperties {
    const props = getPropsFrom(xml);

    const customId = props['CustomID'];
    const id = props['ID'];
    const activationRule = props['ActivationRule'] || '';
    const isGenericRepeatItem = props['IsGenericRepeatItem'] === 'True';

    return {
      ...DEFAULT_BASE_PROPERTIES,
      id,
      customId,
      activationRule,
      isGenericRepeatItem
    };
  }
}
